import {
  FormControlLabel,
  FormControl,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { TAutocompleteOption } from '../AutocompleteField/types';
import { styles } from './styles';
import lodash from 'lodash';
import { ReactNode } from 'react';

type IFormRadioGroupProps = {
  name: string;
  label?: ReactNode;
  onChange?: (value: string) => void;
  options: TAutocompleteOption[];
  row?: boolean;
  disabled?: boolean;
};

export const FormRadioGroup = ({
  name,
  label,
  options,
  onChange,
  row,
  disabled,
}: IFormRadioGroupProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = lodash.get(errors, name);

  return (
    <FormControl error={!!error} disabled={disabled}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {label && (
              <FormLabel sx={styles.label} id={name}>
                {label}
              </FormLabel>
            )}
            <RadioGroup
              name={name}
              row={row}
              value={field.value}
              onChange={(event) => {
                field.onChange(event.target.value);
                onChange?.(event.target.value);
              }}
              sx={{ gap: 1 }}
            >
              {options.map((option, index) => (
                <FormControlLabel
                  key={option.value}
                  label={option.label}
                  control={<Radio ref={!index ? field.ref : undefined} disabled={disabled} />}
                  value={option.value}
                  sx={styles.radioBtn}
                  data-testid={`${name}-${option.value}-radioButton`}
                />
              ))}
            </RadioGroup>
          </>
        )}
      />
      <FormHelperText>{(error as { message?: string })?.message}</FormHelperText>
    </FormControl>
  );
};
